<template>
<main>
<v-container class="grey lighten-4 fill-height">
  <v-row>
            <v-col class="mx-auto" >
              <v-card class="elevation-12 ma-3">
                  <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <v-toolbar-title>Möten du är administratör för</v-toolbar-title>
                  <!-- Möten där du svarat -->
                  
                </v-toolbar>
                <v-card-text>
  <v-data-table
    :headers="headers"
    :items="schedule"
    :items-per-page="10"
    no-data-text="Ingen data tillgänglig"
    :footer-props="{
    'items-per-page-text': 'Rader per sida:',
    'items-per-page-all-text': 'Allt',
    }"
    class="elevation-1"
  >
    <template v-slot:item.title="{ item }">
      <router-link :to="'/schedule/'+item.schedule_link">{{ item.title }}</router-link>
    </template>
  <template v-slot:item.status="{ item }">
      <v-chip @click="openpop(item.reply_deadline_date, item.id)" :color="new Date(item.reply_deadline_date).setHours(0,0,0,0) >= today || item.reply_deadline_date === null?'green':'red'" dark>
        {{ new Date(item.reply_deadline_date).setHours(0,0,0,0) >= today || item.reply_deadline_date === null?'öppen':'stängd' }}
        </v-chip>
    </template>
    <template v-slot:item.reply_deadline_date="{ item }">
      {{ item.reply_deadline === 'yes'?item.reply_deadline_date:'Ingen tidsfrist' }}
    </template>
    <template v-slot:item.id="{ item }">
      <v-btn :to="'/account/participants/'+item.id" v-show="item.participant_count > 0"><v-icon  
                    >fas fa-external-link-alt</v-icon></v-btn>
    </template>
    <template v-slot:item.user_id="{ item }">
      <v-btn :to="'/editmeeting/'+item.id" x-small dark color="primary mr-2">Titel / beskrivning</v-btn>
      <v-btn :to="'/updateschedule/'+item.id" x-small  color="primary mr-2">Datum / alternativ</v-btn>
    </template>
    <template v-slot:footer.page-text="items">
       {{ items.pageStart }} - {{ items.pageStop }} av {{ items.itemsLength }} 
       </template>
  </v-data-table>
                </v-card-text>
            </v-card>
            <v-card class="elevation-12 ma-3">
                  <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <v-toolbar-title>Möten där du svarat</v-toolbar-title>
                  
                </v-toolbar>
                <v-card-text>
  <v-data-table
    :headers="inheaders"
    :items="ischedule"
    :items-per-page="10"
    no-data-text="Ingen data tillgänglig"
    :footer-props="{
    'items-per-page-text': 'Rader per sida:',
    'items-per-page-all-text': 'Allt',
    }"
    class="elevation-1"
  >
    <template v-slot:item.title="{ item }">
      <router-link :to="'/schedule/'+item.schedule_link">{{ item.title }}</router-link>
    </template>
  <template v-slot:item.status="{ item }">
      <v-chip :color="new Date(item.reply_deadline_date).setHours(0,0,0,0) >= today || item.reply_deadline_date === null?'green':'red'" dark>
        {{ new Date(item.reply_deadline_date).setHours(0,0,0,0) >= today || item.reply_deadline_date === null?'öppen':'stängd' }}
        </v-chip>
    </template>
    <template v-slot:item.reply_deadline_date="{ item }">
      {{ item.reply_deadline === 'yes'?item.reply_deadline_date:'Ingen tidsfrist' }}
    </template>
  </v-data-table>
                </v-card-text>
            </v-card>
            <v-dialog v-model="alert" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
        {{alertmsg}}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color=" darken-1" text @click="alert=false">Nej</v-btn>
          <v-btn color="green darken-1" text @click="changestatus()">Ja</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
            </v-col>
        </v-row>
  </v-container>
  </main>
</template>


<script>
import store from "../../../store";
import axios from "axios";
  export default {
    data () {
      return {
        store: store,
        headers: [
          {
            text: 'Titel',
            align: 'start',
            sortable: false,
            value: 'title',
          },
          { text: 'Antal svar', value: 'participant_count' },
          { text: 'Status', value: 'status' },
          { text: 'Tidsfrist', value: 'reply_deadline_date' },
          { text: 'Deltagare', value: 'id' },
          { text: 'Inställningar', value: 'user_id' },
        ],
        inheaders: [
          {
            text: 'Titel',
            align: 'start',
            sortable: false,
            value: 'title',
          },
          { text: 'Status', value: 'status' },
          { text: 'Tidsfrist', value: 'reply_deadline_date' },
        ],
        schedule: [],
        ischedule: [],
        replydate: '',
        schid: '',
        alertmsg: '',
        alert: false,
        today:new Date().setHours(0,0,0,0)
      }
    },
    created: async function() {
      if (!this.store.state.isLoggedIn) this.$router.replace("/login");
        this.outgoing()
        this.incoming()
    },
    methods: {
      getColor (status) {
        if (status === 'yes') return 'green'
        else return 'red'
      },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
    async outgoing () {
      var config = {
            method: "get",
            url: `${this.store.state.baseURL}outgoingschedules/${this.store.state.user.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.schedule = resp.data.schedule;
        // console.log(new Date(this.schedule[0].reply_deadline_date).setHours(0,0,0,0))
    },
    async incoming () {
      var config = {
            method: "get",
            url: `${this.store.state.baseURL}incomingschedules/${this.store.state.user.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.ischedule = resp.data.schedule;
        // console.log(new Date(this.schedule[0].reply_deadline_date).setHours(0,0,0,0))
    },
    openpop(date, id){
      this.schid = id
      this.replydate = date
      if(new Date(date).setHours(0,0,0,0) >= this.today || date === null){
        this.alertmsg = 'Är du säker på att du vill stänga schemat?'
      }else{
        this.alertmsg = 'Är du säker på att du vill öppna schemat?'
      }
      this.alert = true
    },
    changestatus(){
      var config = {
            method: "get",
            url: `${this.store.state.baseURL}openclose/${this.schid}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        axios(config);
        this.alert = false
        this.outgoing()
    }
    },
  }
</script>